package amazon.lastmile.inject

import app.nestbridge.feature.profile.presentation.CreateProfessionalProfilePresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateProfessionalProfilePresenterFactory::class)
public interface AppNestbridgeFeatureProfilePresentationCreateProfessionalProfilePresenterFactory {
  @Provides
  @IntoSet
  public fun provideCreateProfessionalProfilePresenterFactoryFactoryMultibinding(createProfessionalProfilePresenterFactory: CreateProfessionalProfilePresenterFactory): Presenter.Factory = createProfessionalProfilePresenterFactory
}
